import React from "react";
import { Empty as AntEmpty } from "antd";

export const Empty = ({ style = {} }) => {
	return <AntEmpty description="సమాచారం లేదు" {...{ style }} />;
};
